import { render } from "./ServiceTable.vue?vue&type=template&id=3589c05b"
import script from "./ServiceTable.vue?vue&type=script&lang=js"
export * from "./ServiceTable.vue?vue&type=script&lang=js"

import "./ServiceTable.vue?vue&type=style&index=0&id=3589c05b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__